import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

const columnData = [
    { id: 'id', numeric: false, disablePadding: false, label: 'Invoice Number' },
    { id: 'installment', numeric: false, disablePadding: false, label: 'Installment' },
    { id: 'date', numeric: false, disablePadding: false, label: 'Invoice Date' },
    { id: 'paidAmount', numeric: true, disablePadding: false, label: 'Paid Amount' }
];

class SuccessPaymentEnhancedTableHead extends Component {
    

    render() {
        const { order, orderBy } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {columnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                padding={column.disablePadding ? 'none' : 'default'}                              
                            >                                
                                    {column.label}                               
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

SuccessPaymentEnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

export default SuccessPaymentEnhancedTableHead;


// WEBPACK FOOTER //
// ./src/SuccessPaymentEnhancedTableHead.js